import { getCookie } from "./cookies";
export default function authHeader() {
  const userString = localStorage.getItem("user");
  const user = userString && JSON.parse(userString);
  const oauthToken = getCookie("oauthToken");
  const accessToken = localStorage.getItem("accessToken");

  if (accessToken) {
    const headers = { Authorization: `Bearer ${accessToken}` };
    return headers;
  }
}
